export const dataLayerPush = (e, eventElement = null, category = null, action = null, label = null) => {
    const dataLayer = global.dataLayer;
    const text = e.currentTarget.textContent;
    const event = eventElement ? eventElement : 'CTA Button'
    const eventAction = action ? action : text;
    const eventCategory = category ? category : 'Button';
    const eventLabel = label ? label : global.location.pathname;
    const pushObject = {
        event,
        eventCategory,
        eventAction,
        eventLabel
    }
    console.log(pushObject);
    dataLayer.push(pushObject);
}

export const containsSubdomain = (subdomain) => {
    if (typeof window === 'undefined') { return; }
    const currentUrl = window.location.hostname;
    const regex = new RegExp(`^${subdomain}\\.`);
    return regex.test(currentUrl);
};


// WEBPACK FOOTER //
// ./src/utils/index.js